"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import _ from "lodash";
import { Component, Mixins, PropSync } from "vue-property-decorator";
let BatchOperateRenew = class extends Mixins(AccountSessionMixins) {
  get show() {
    for (let item of this._controller.selected) {
      if (!item.marks.is("IS_ADMIN")) {
        return false;
      }
    }
    if (this._controller.query.filter.group === "vdgroup_system_recycle") {
      return false;
    }
    return true;
  }
  batchRenew() {
    return __async(this, null, function* () {
      try {
        let ids = _.map(this._controller.selected, "oldId");
        yield API.post(`api://base.auth/api/v7/payment/virtualdesktop-verification/renew`, {
          ids
        });
        let items = {
          vds: this._controller.selected
        };
        this.$router.push({
          name: "payment",
          query: {
            style: "renew"
          },
          params: {
            items: JSON.stringify(items)
          }
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("controller")
], BatchOperateRenew.prototype, "_controller", 2);
BatchOperateRenew = __decorateClass([
  Component
], BatchOperateRenew);
export {
  BatchOperateRenew as default
};
